import { SwitchField, Modal, Button, Link, Icon } from '@dev-spendesk/grapes';
import { useState } from 'react';
import { Trans } from 'react-i18next';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import FEATURES from 'src/core/constants/features';
import { useDisableFeature } from 'src/core/modules/company/general-settings/components/SpendingMethods/hooks/useDisableFeature';
import { useEnableFeature } from 'src/core/modules/company/general-settings/components/SpendingMethods/hooks/useEnableFeature';

export function SpanishDprSwitch({
  isSpanishDprEnabled,
}: {
  isSpanishDprEnabled: boolean;
}) {
  const { t } = useTranslation('global');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [enableFeature] = useEnableFeature();
  const [disableFeature] = useDisableFeature(FEATURES.SPANISH_DPR);

  const handleSwitch = async () => {
    if (isSpanishDprEnabled) {
      setIsModalOpen(true);
    } else {
      await enableFeature({ featureCode: FEATURES.SPANISH_DPR });
    }
  };

  const handleDisable = async () => {
    await disableFeature();
    setIsModalOpen(false);
  };

  return (
    <div className="gap-8">
      <SwitchField
        label={
          <div className="heading-l">{t('settings.links.spanishDpr')}</div>
        }
        fit="parent"
        isChecked={isSpanishDprEnabled}
        onChange={handleSwitch}
      />
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={t('bookkeep.settings.spanishDpr.disableFeatureModal.title')}
        iconName="triangle-warning"
        iconVariant="warning"
        actions={[
          <Button
            key="cancel"
            variant="secondaryNeutral"
            text={t('misc.cancel')}
            onClick={() => setIsModalOpen(false)}
          />,
          <Button
            key="turnOff"
            variant="primaryWarning"
            text={t(
              'bookkeep.settings.spanishDpr.disableFeatureModal.turnOffButton',
            )}
            onClick={handleDisable}
          />,
        ]}
      >
        {t('bookkeep.settings.spanishDpr.disableFeatureModal.content')}
      </Modal>
      <div className="text-content-secondary-bg-secondary body-m">
        <Trans i18nKey="bookkeep.settings.spanishDpr.description">
          <Link
            href="https://helpcenter.spendesk.com/articles/9540095-how-to-digitise-your-paper-receipts-in-spain"
            target="_blank"
            rel="noopener noreferrer"
          />
        </Trans>
        <span className="ml-4 inline-block">
          <Link
            href="https://helpcenter.spendesk.com/articles/9540095-how-to-digitise-your-paper-receipts-in-spain"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('bookkeep.settings.spanishDpr.helpCenter')}
            <Icon name="arrow-top-right-square" className="ml-1" />
          </Link>
        </span>
      </div>
    </div>
  );
}
